import React from 'react';
import SimpleCategoryPicker from '~/components/Search/SimpleCategoryPicker';
import useFacetFiltering from '~/contexts/facetFiltering/useFacetFiltering';
import { RailsPageView } from '~/typings/services/rails/tile';

interface Props {
  pageView: RailsPageView | null;
}

const SupplementalCategoryPicker: React.FC<Props> = ({ pageView }) => {
  const { lander } = useFacetFiltering();

  // Only show the supplemental category picker if the lander has categories and there's a
  // lander-featured-categories block that would replace the category picker at the top of the page
  if (
    !lander ||
    !lander.show_categories ||
    !pageView ||
    !pageView.blocks.find(
      block => block.layout === 'lander-featured-categories',
    )
  ) {
    return null;
  }

  return (
    <div className="-mt-8 pt-16" id="categories-section">
      <SimpleCategoryPicker heading="More Categories" />
    </div>
  );
};

export default SupplementalCategoryPicker;
